module.exports = __webpack_public_path__ + "images/ec64086f.www_3_group_chs.png";


//////////////////
// WEBPACK FOOTER
// ./images/groupintro/www_3_group_chs.png
// module id = 617
// module chunks = 0